import PhotoShelterGallery from 'types/PhotoShelterGallery';
import api from './index';
import camelize from 'camelize';

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchPhotoShelterGalleries: builder.query<
      PhotoShelterGallery[],
      { destinationId: number; query: string }
    >({
      query: ({ query, destinationId }) => ({
        url: `photoshelter-galleries?query=${query}&destination_id=${destinationId}`,
      }),
      transformResponse: camelize,
    }),
  }),
});

export default extendedApi;

export const {
  useSearchPhotoShelterGalleriesQuery,
  useLazySearchPhotoShelterGalleriesQuery,
} = extendedApi;
